import { axios } from 'libs';

const resource = '/processos-caixa';

export const getProcessosByCaixa = id => {
  return axios.get(`${resource}/processos/${id}`);
};
